import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SliderModelService } from '../../../services/infrastructure/sliderModel.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-grower-program-name',
  templateUrl: './grower-program-name.component.html',
  styleUrls: ['./grower-program-name.component.scss']
})
export class GrowerProgramNameComponent implements OnInit {
  subscription = new Array<Subscription>();
  displayedColumns: string[] = [
    'rowNumber',
    'programName',
    'cropYear',
    'programType',
    'budgetType',
    'approval',
    'productLine',
    'EnrollmentStart',
    'EnrollmentEnd',
    'HybridVarietyTypes'
  ];
  programDataSource: any;
  selectedElement: any;
  selectedRowId: number = 0;

  constructor(private sliderModelService: SliderModelService,
    private loaderService: LoaderService,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.sliderModelService.initializegpProgramSliderValue.subscribe(data => {
      this.programDataSource = data;
      this.loaderService.setLoaderStatus(false);
    }));
  }

  selectRow(element) {
      this.selectedElement = element;
      this.selectedRowId = element.id;
  }

  selectProgram() {
    this.sliderModelService.selectedProgramValue.next(this.selectedElement);
    this.sliderModelService.growerProgramNameSlider.next(false);
    this.sliderModelService.close();
  }
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
